import React, { FunctionComponent } from 'react';

import Helmet from 'react-helmet';
import { ArticleFragmentResponse } from '../../../fragments/article';
import useStructuredData from './useStructuredData';

export type StructuredDataProps = {
  article: ArticleFragmentResponse;
};

const StructuredData: FunctionComponent<StructuredDataProps> = (props) => {
  const { article } = props;

  const data = useStructuredData(article);

  if (!article) {
    return null;
  }
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default StructuredData;
